module.exports = __webpack_public_path__ + "static/img/nav-list-3.e9147ff6.png";